import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { Link, NavLink } from "react-router-dom";
import { Search } from "./Search";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 1,
    top: 1,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
    backgroundColor: "#F1B80F",
  },
}));

const Navbar = (props) => {
  const [loggedInUser, setLoggedInUser] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(true);
  const [userInfo, setUserInfo] = useState(true);

  const quantity = useSelector((state) => state.cart.quantity);

  useEffect(() => {
    const userLoggedIn = JSON.parse(localStorage.getItem("user"))?.others;
    if (userLoggedIn) {
      const foundUser = userLoggedIn;
      setLoggedInUser(foundUser);
    }
  }, []);

  const handleLogout = () => {
    setLoggedInUser(false);
    localStorage.clear();
    window.location.reload();
  };

  const handleMenu = (type) => {
    if (type === "open") {
      setToggleMenu(false);
      setUserInfo(true);
    } else {
      setToggleMenu(true);
    }
  };

  const handleUser = (type) => {
    setUserInfo(!userInfo);
    setToggleMenu(true);
  };

  let activeStyle = {
    borderBottom: "3px solid #f9d923",
    paddingBottom: "17px",
    color: "#374151",
  };

  return (
    <div className="navbar flex justify-between items-center gap-2 px-2 md:px-6 lg:px-20 w-full h-14 font-Roboto shadow-md bg-white fixed top-0 z-50">
      <div className="left flex flex-1 items-center gap-9 md:gap-4 h-full relative">
        <div className="brand ">
          <h3 className="text-2xl font-bold text-primary">ShopI</h3>
        </div>
        <ul className="hidden text-l text-lg font-medium lg:gap-6 text-gray-500 md:gap-2 md:flex">
          <li className="active:border-b-primary hover:border-3 hover:divide-solid cursor-pointer">
            <NavLink
              to="/"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span className="hover:text-gray-700 transition-all">Home</span>
            </NavLink>
          </li>

          <li className="md:border-b-primary hover:border-3 hover:divide-solid cursor-pointer">
            <NavLink
              to="/products"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span className="hover:text-gray-700 transition-all">
                Categories
              </span>
            </NavLink>
          </li>

          <li className="md:border-b-primary hover:border-3 hover:divide-solid cursor-pointer">
            <NavLink
              to="/contact"
              style={({ isActive }) => (isActive ? activeStyle : undefined)}
            >
              <span className="hover:text-gray-700 transition-all">
                Contact
              </span>
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="center flex flex-1 justify-center">
        <Search categoriesSearch={props.categoriesSearch} />
      </div>
      <div className="right flex flex-1 items-center justify-end gap-2">
        <Link to="/cart">
          <div className="cart">
            <IconButton aria-label="cart">
              <StyledBadge badgeContent={quantity} color="primary">
                <ShoppingCartIcon />
              </StyledBadge>
            </IconButton>
          </div>
        </Link>
        <div className="user">
          {loggedInUser ? (
            <div className="relative">
              <div
                onClick={() => handleUser()}
                className="avatar w-11 h-11 rounded-full overflow-hidden border-2 border-gray-200 object-cover drop-shadow-md "
              >
                <img src={loggedInUser.image} alt="user" />
              </div>
              {userInfo ? null : (
                <div
                  onClick={() => handleLogout()}
                  className="flex absolute top-[3.1rem] right-[calc(50%-64px)] w-32 justify-center p-2 text-base text-gray-300 hover:text-primary transition bg-dark cursor-pointer"
                >
                  logout
                </div>
              )}
            </div>
          ) : (
            <div className="login_singup flex gap-2 md:gap-4 items-center">
              <Link to="/login">
                <h4 className="hover:text-gray-700 text-base md:text-lg text-center font-Roboto font-medium text-gray-500 transition-all">
                  login
                </h4>
              </Link>
              <Link to="/singup">
                <h4 className="hidden md:block py-1 px-2 md:px-3 text-base md:text-lg text-center font-Roboto font-medium rounded-full border-2 border-gray-500 hover:bg-primary hover:border-white hover:text-gray-600 transition-all">
                  singup
                </h4>
              </Link>
            </div>
          )}
        </div>

        <div className="menu flex items-center md:hidden ml-1">
          {toggleMenu ? (
            <AiOutlineMenu
              className="text-gray-500 h-6 w-6 "
              onClick={() => handleMenu("open")}
            />
          ) : (
            <AiOutlineClose
              className="text-gray-500 h-6 w-6 "
              onClick={() => handleMenu("close")}
            />
          )}
          {toggleMenu ? null : (
            <div className="flex flex-col w-32 fixed bg-dark right-0 top-14 z-50 drop-shadow-lg shadow-xl rounded-bl-sm">
              <span className="text-center text-base p-2 font-Roboto font-medium text-gray-700 bg-primary hover:bg-primary-200 hover:cursor-pointer transition-all">
                <Link to="/singup">singup</Link>
              </span>
              <span className="text-center text-base p-2 font-Roboto font-normal text-gray-300 hover:text-gray-200 hover:cursor-pointer transition-all">
                <Link to="/">Home</Link>
              </span>
              <span className="text-center text-base p-2 font-Roboto font-normal text-gray-300 hover:text-gray-200 hover:cursor-pointer transition-all">
                <Link to="/products">Categories</Link>
              </span>
              <span className="text-center text-base p-2 font-Roboto font-normal text-gray-300 hover:text-gray-200 hover:cursor-pointer transition-all">
                <Link to="/contact">Contact</Link>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
